export default __webpack_public_path__ + "images/bcbab41247ac56ebb24416ab7b67a16f.png";